export const uppercaseFirstLetter = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const replaceUnderscoreWithSpace = (str: string | null | undefined) => {
  if (!str) return '';
  return str.replace(/_/g, ' ');
};
